export default __webpack_public_path__ + "static/media/gauchoparilla.2cfaa752.jpeg";